export const HTTP_401_ERROR = 401;
export const HTTP_403_ERROR = 403;
export const HTTP_404_ERROR = 404;
export const HTTP_408_ERROR = 408;
export const HTTP_422_ERROR = 422;
export const HTTP_500_ERROR = 500;
export const TOKEN_KEY = "tokens";
